import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA7Fh1ev53Ol6aAMWdh1YwNFGuc3CrPY4I",
  authDomain: "inventoryapp-1a691.firebaseapp.com",
  projectId: "inventoryapp-1a691",
  storageBucket: "inventoryapp-1a691.firebasestorage.app",
  messagingSenderId: "924346423734",
  appId: "1:924346423734:web:49431c14ca6b4f8800c917"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
